export default __webpack_public_path__ + "static/onboarding-automation-6800b8ae1f370ccba14fcd397450dfee.mp4";